export const MuiTypography = {
  MuiTypography: {},
};
